import sliceCreator from '../../index.jsx';
import {GET_ALL_VILLAGES} from '../../../constants/index.jsx';
const _getAllVillagesAction = sliceCreator('GET_ALL_VILLAGES', GET_ALL_VILLAGES, 'get');

const { asyncAction: getAllVillagesAction, reducer, clearData: clearGetAllVillagesAction } = _getAllVillagesAction;

export default reducer;

export {
    getAllVillagesAction,
    clearGetAllVillagesAction
}